import './Oops.css';

import {Card, CardContent, Typography} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';

const Oops = () => {
  const {t} = useTranslation();
  const errorImageIcon = (
    <svg
      focusable="false"
      aria-hidden="true"
      fill="#999"
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
    </svg>
  );

  return (
    <div className={'Canvas'}>
      <div className={'CardPosition'}>
        <Card>
          <CardContent>
            <div className={'CriticalImagePosition'}>{errorImageIcon}</div>
            <Typography
              className="TitleStyle"
              fontWeight="semibold"
              component="h2"
              size="xl"
            >
              {t('CURRENTLY_UNAVAILABLE')}
            </Typography>
            <Typography
              className="DescStyle"
              gutterBottom
              color="text.secondary"
              component="p"
            >
              {t('OOPS_DESC')}
            </Typography>
            <Typography
              className="DescStyle"
              gutterBottom
              color="text.secondary"
              component="p"
            >
              {t('OOPS_DESC_1')}
            </Typography>
            <Typography
              className="OopsLoginLink"
              gutterBottom
              color="text.tertiary"
              component="p"
            >
              <a href="/signOut" className={'LinkStyle'}>
                {t('LOGIN_AGAIN')}
              </a>
            </Typography>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default Oops;
